import classical from './classical'

export default {
    participant: {
        icon: 'team',
        text: 'Peserta',
        route: 'admin.participant',
        role: {
            classical: [ 'admin' ],
            paper: [ 'admin' ],
            performance: [ 'admin' ],
            project: [ 'admin'],
            evaluation: [ 'admin' ]
        },
        children: Object.assign({}, classical)
    }
}
